import { FetchCampaignsV2Response } from "@/api/interfaces/responses/campaigns";
import { EmailCadence } from "@/interfaces/campaign";

export function calculateInitialEmailCadence(
  selectedCampaigns: FetchCampaignsV2Response[],
): EmailCadence {
  if (selectedCampaigns.length === 0) {
    return EmailCadence.Unsubscribed;
  }

  if (selectedCampaigns.length === 1) {
    return selectedCampaigns[0].email_cadence;
  }

  // Check if all campaigns have the same email cadence
  const firstCadence = selectedCampaigns[0].email_cadence;
  const allSame = selectedCampaigns.every(
    (campaign) => campaign.email_cadence === firstCadence,
  );

  return allSame ? firstCadence : EmailCadence.Daily;
}
